<!--
 * @Author: Dzy
 * @Date: 2022-11-09 19:39:34
 * @LastEditors: Dzy
 * @LastEditTime: 2023-02-20 09:51:42
 * @Description: 自定义图标库组件——图标+按钮
-->
<template>
  <span class="ADLButtonIcon" @mouseover="mouseOver" @mouseleave="mouseLeave">
    <a-button v-if="iconHref" :type="type" :danger="danger" :disabled="disabled" :loading="loading">
      <!-- 应用阿里icon组件  官方固定写法  不封装也可以在页面中直接使用-->
      <svg v-if="!hoverFlag" class="icon-table" aria-hidden="true">
        <use :xlink:href="'#icon-' + iconHref" />
      </svg>
      <svg v-else class="icon-table" aria-hidden="true">
        <use :xlink:href="'#icon-' + iconHref + '_hov'" />
      </svg>
      {{ props.text }}
    </a-button>
    <a-button v-else :type="type" :danger="danger" :disabled="disabled" :loading="loading">
      {{ props.text }}
    </a-button>
  </span>
</template>
<script setup>
import { ref } from 'vue'
const props = defineProps({
  iconHref: String,
  allowHover: Boolean,
  danger: Boolean,
  type: String,
  text: String,
  disabled: Boolean,
  loading: { type: Boolean, default: false }
})

const hoverFlag = ref(false)

const mouseOver = () => {
  if (props.allowHover) {
    setTimeout(() => (hoverFlag.value = true), 100)
  }
}

const mouseLeave = () => {
  if (props.allowHover) {
    setTimeout(() => (hoverFlag.value = false), 100)
  }
}

/*
  iconHref 说明：
  icon id说明
  组成：{文件类型}_{适用类型}_{功能}(_{使用场景}(default默认场景不填))
  文件类型：i:图标；p：图片；v：视频；s:特殊文件
  适用类型：common：通用类型；table：专用于表格类型；form：专用于表单类型
  功能：编辑：edit；重置密码:resetPwd;……
  使用场景：hov：悬浮场景
  例如：
  i_common_edit:通用类型默认编辑图标
*/
</script>
